import { JobInsight } from './jobs.model';
import { CredentialSummary } from './speak-your-skills.model';

import type { RelevancyFeedback } from './relevancy-feedback.model';

export type NextStepStatus = 'completed' | 'active' | 'locked' | 'marked_for_completion';
export type NextStepActionType = 'action' | 'learning' | 'job';
export type ChangeStepFeedback =
  | 'not_relevant'
  | 'already_done'
  | 'too_difficult'
  | 'not_interested'
  | 'other';

export interface BulletPointDetailItem {
  id: string;
  text: string;
}

export interface BulletPointsDetails {
  type: 'bullet_points';
  items: BulletPointDetailItem[];
}

export interface CoursesDetails {
  type: 'courses';
  items: CredentialSummary[];
}

export interface JobsDetails {
  type: 'jobs';
  items: JobInsight[];
}

export type NextStepDetails = BulletPointsDetails | CoursesDetails | JobsDetails;

export interface FocusNextStep {
  id: string;
  heading: string;
  description: string;
  action_type: NextStepActionType;
  status: NextStepStatus;
  isNew?: boolean;
  created_at?: string;
  completed_at?: string;
  details?: NextStepDetails;
  relevancy_feedback?: RelevancyFeedback;
}

export const LOCKED_STEP_PLACEHOLDERS: FocusNextStep[] = [
  { id: 'locked-1', heading: '', description: '', action_type: 'action', status: 'locked' },
  { id: 'locked-2', heading: '', description: '', action_type: 'learning', status: 'locked' },
];

export interface FocusResponse {
  id: number;
  next_steps: FocusNextStep[];
}

export interface NextStepResponse {
  id: string;
  status: NextStepStatus;
}
